import { SVGProps } from "react";

export function GoldBarsIcon({ size = 24, color = "#FFA000", ...props }: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...(props as any)}>
      <path
        d="M1 22.0001L2.5 17.0001H9.5L11 22.0001H1ZM13 22.0001L14.5 17.0001H21.5L23 22.0001H13ZM6 15.0001L7.5 10.0001H14.5L16 15.0001H6ZM23 6.0501L19.14 7.1401L18.05 11.0001L16.96 7.1401L13.1 6.0501L16.96 4.9601L18.05 1.1001L19.14 4.9601L23 6.0501Z"
        fill={color}
      />
    </svg>
  );
}
